import { createSelector } from 'reselect';

// Selectors
import {
  getPromotionServices,
  getReservationId,
  getServicePoint as getServicePointInAppt
} from 'store/reducers/appointment/selectors';

// Utils
import { applyPromotionToPackage } from 'utils/promotions';

const getPackages = ({ packages }) => packages;

export const getAllServicePoints = createSelector(getPackages, packages => {
  if (packages.servicePoints) {
    return packages.servicePoints;
  }
});

export const getPrevServicePoint = createSelector(getPackages, packages => {
  if (packages.servicePoints) {
    return packages.servicePoints.find(({ position }) => position === 0);
  }
});

export const getServicePoint = createSelector(getPackages, packages => {
  if (packages.servicePoints) {
    return packages.servicePoints.find(({ position }) => position === 1);
  }
});

export const getNextServicePoint = createSelector(getPackages, packages => {
  if (packages.servicePoints) {
    return packages.servicePoints.find(({ position }) => position === 2);
  }
});

export const getServicePackageList = createSelector(
  getServicePoint,
  getPromotionServices,
  (servicePoint, promotionServices) => {
    if (servicePoint) {
      if (promotionServices) {
        return servicePoint.menuTypes.map(menuType =>
          applyPromotionToPackage(promotionServices, menuType)
        );
      } else {
        return servicePoint.menuTypes;
      }
    } else {
      return [];
    }
  }
);

export const getServicePackage = createSelector(
  getServicePoint,
  servicePoint => {
    if (servicePoint) {
      return servicePoint.menuTypes[0];
    }
  }
);

export const getPackageMileages = createSelector(
  getPrevServicePoint,
  getServicePoint,
  getNextServicePoint,
  (prevServicePoint = {}, servicePoint = {}, nextServicePoint = {}) => [
    prevServicePoint.mileage,
    servicePoint.mileage,
    nextServicePoint.mileage
  ]
);

export const getDisplayMonths = createSelector(
  getServicePoint,
  ({ months }) => +months > 0
);

export const getPackageMonths = createSelector(
  getPrevServicePoint,
  getServicePoint,
  getNextServicePoint,
  (prevServicePoint = {}, servicePoint = {}, nextServicePoint = {}) => [
    prevServicePoint.months,
    servicePoint.months,
    nextServicePoint.months
  ]
);

export const getExactMileageFlag = createSelector(
  getPackages,
  getReservationId,
  getServicePointInAppt,
  ({ useExactMileageFlag }, reservationId, servicePointInAppt) => {
    if (reservationId && servicePointInAppt) {
      return 1;
    }
    return useExactMileageFlag;
  }
);



// WEBPACK FOOTER //
// ./src/store/reducers/packages/selectors.js